import { css } from "@emotion/css";
import { withBasicStyles } from "@/styles/common";

export const useStyles = withBasicStyles(() => ({
  providerWrapper: css`
    display: flex;
    height: 100%;
    position: relative;
    overflow: hidden;
  `,

  chatbotWrapper: css`
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
  `,

  // 居中显示
  content: css`
    flex: 1;
    justify-content: center;
    max-width: 800px;
  `,
}));
